import React from 'react';
import "hammerjs";

import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartCategoryAxisItem
  } from '@progress/kendo-react-charts';

import ReportTooltip from './ReportTooltip';
import { numberFormatter } from '../common/formatter';

const WeeklyAllocatedBudgetChart = ({weeklyAllocations}) => {
    if(!weeklyAllocations || !weeklyAllocations.length) return null;
    return (
        <div className='weekly-allocation-container'>
            <div className='report-chart-title'>
                <h3 className='font-secondary font-weight-500 font-size-18 text-color-dark'>Publications Distribution</h3>
                <ReportTooltip description={'How your budget is distributed among every week'}/>
            </div>          
            <div className ='weekly-allocation-chart'>
                <Chart
                    style={{
                    height: 300
                    }}
                    pannable={{
                        lock: "y"
                      }}
                      zoomable={{
                        mousewheel: {
                          lock: "y"
                        }
                      }}
                >
                    <ChartSeries>
                        <ChartSeriesItem
                        color='#BB61C2'
                        key='week'
                        border={{
                            color: 'none'
                        }}
                        tooltip={{
                            visible: true,
                            format:"c0"
                        }}
                        type="column"
                        field='totalAllocation'
                        categoryField="week"
                        data={weeklyAllocations}
                        labels={{
                            visible: true,
                            format: "c0",
                            content: (e) => `${numberFormatter.formatShortCurrency(e.value)}`
                        }}
                        />
                    </ChartSeries>
                    <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                        labels={{
                            rotation: "auto"
                          }}
                        title={{text:"Weeks"}}
                    />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                    <ChartValueAxisItem
                        labels={{
                            format: "c0"
                          }}
                    />
                    </ChartValueAxis>
                 </Chart>

            </div>

        </div>
    );
};

export default WeeklyAllocatedBudgetChart;
